
import { TariffTypeEntity, EMPTY_TARIFF_TYPE_ENTITY } from "domain/entity/TariffType/TariffTypeEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface TariffTypeDropdownOptions {
    tariffTypeTypeDropdownOptions: DropdownProps[],
}
export interface MasterChangeState extends BaseViewChangeSate {
    editingEntity: TariffTypeEntity,
}

export interface TariffTypeMaintenanceModel {
    isLoading: boolean,
    tableData: TariffTypeEntity[],
    currentSelectedRow: TariffTypeEntity,
    selectedRows: TariffTypeEntity[],
    dynamicOptions: TariffTypeDropdownOptions,
    masterState: MasterChangeState,
    isBackMaster: boolean,
    isShowEditPanel: boolean,
}

export const EMPTY_MASTER_TARIFF_TYPEANY_MODEL: TariffTypeMaintenanceModel = {
    isLoading: false,
    tableData: [],
    currentSelectedRow: { ...EMPTY_TARIFF_TYPE_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        tariffTypeTypeDropdownOptions: []
    },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        editingEntity: EMPTY_TARIFF_TYPE_ENTITY,
    },
    isBackMaster: true,
    isShowEditPanel: false,
}